
export enum eViewType {
    view = "view",
    edit = "edit",
    new = "new"
}

export enum eAdminType {
    configurator = "configurator",
    quoteOutput = "quoteOutput",
    scene = "scene",
    productRule = "productRule",
    quoteHeader = "quoteHeader",
    layout = "layout"
}

export enum eAlertType {
    info = "info",
    error = "error",
    success = "success"
}

export enum eColorFormat {
    kbcolor = "kbcolor",
    hex = "hex",    
    hsl = "hsl",
    hslString = "hslString",
    hsv = "hsv",
    hsvString = "hsvString",
    rgb = "rgb",
    rgbString = "rgbString"
}

export enum eColorOperation {
    lighten = "lighten",
    brighten = "brighten",
    darken = "darken",
    saturate = "saturate",
    desaturate = "desaturate"
}